import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Sidebar } from './Sidebar';

interface WeightFilterProps {
  onClose: () => void;
  onChange: (weightFilters: [boolean, boolean]) => void;
  selectedWeightFilters: [boolean, boolean];
  runFilter: () => void;
}

export const WeightFilter: React.FC<WeightFilterProps> = ({
  onClose,
  onChange,
  selectedWeightFilters,
  runFilter
}) => {
  const onChangeHasWeightFilter = (_evt: React.SyntheticEvent, val: boolean) => {
    const newSelectedWeightFilters: [boolean, boolean] = [val, selectedWeightFilters[1]];
    onChange(newSelectedWeightFilters);
  };

  const onChangeNoWeightFilter = (_evt: React.SyntheticEvent, val: boolean) => {
    const newSelectedWeightFilters: [boolean, boolean] = [selectedWeightFilters[0], val];
    onChange(newSelectedWeightFilters);
  };

  return (
    <Sidebar title="Weight Status Filter" onClose={onClose} showDoneButton={false}>
      <div style={{ padding: 24 }}>
        <div>
          <FormControlLabel
            onChange={onChangeHasWeightFilter}
            control={<Checkbox />}
            label="Has weight"
            checked={selectedWeightFilters[0]}
          />
        </div>
        <div>
          <FormControlLabel
            onChange={onChangeNoWeightFilter}
            control={<Checkbox />}
            label="No weight"
            checked={selectedWeightFilters[1]}
          />
        </div>
      </div>
    </Sidebar>
  );
};
